import { Button, Typography } from '@mui/material';
import React, { useState, } from 'react';
import { useTextEntry } from "./textEntry";

export default function usePolicyList( 
    initialList: string[], 
    validationFunction: (value: string) => boolean
) { 
    const [showError, setShowError] = useState(false);
    const [policyList, setPolicyList] = useState<string[]>(initialList);
    const validFunc = (name: string) => {
        return (validationFunction(name) && policyList.indexOf(name) < 0);
    }
    const {
        component: newPolicyField,
        value: newPolicyName,
        setValue: setNewPolicyName,
        isValid: isNewPolicyNameValid
    } = useTextEntry(
        "", showError,
        "New Policy Name",
        validFunc
    );
    const addPolicyName = () => {
        console.log(isNewPolicyNameValid);
        if (isNewPolicyNameValid) {
            const newList = [...policyList];
            newList.push(newPolicyName);
            setPolicyList(newList);
            setNewPolicyName("");
            setShowError(false);
        } else {
            setShowError(true);
        }
    }

    const removePolicyName = (name: string) => {
        const nameIndex = policyList.indexOf(name);
        if (nameIndex < 0) return;
        const newList = [...policyList];
        newList.splice(nameIndex, 1);
        setPolicyList(newList);
    }
    console.log(policyList);
    const policyListComp = <>
        <ul style={{listStyle: "none"}}>
            {policyList.map((name) => <li style={{display:'flex', alignItems:"center", justifyContent:"space-between"}}>
                <Typography>{name}</Typography>
                <Button 
                    onClick={() => removePolicyName(name)}
                    color="error"
                >
                    Delete
                </Button>
            </li>)}
        </ul>
    </>;

    const component = <>
        <Typography variant='h6'>Policies</Typography>
        <span style={{display:"flex", alignItems:"center", justifyItems:"center"}}>
            {newPolicyField}
            <Button onClick={addPolicyName}>Add policy</Button>
        </span>
        {policyListComp}
    </>;
    return {
        component,
        policyList,
        setPolicyList
    }
}
